import { render, staticRenderFns } from "./WeightFieldDisplayEdit.vue?vue&type=template&id=5f2a5e17&scoped=true&"
import script from "./WeightFieldDisplayEdit.vue?vue&type=script&lang=js&"
export * from "./WeightFieldDisplayEdit.vue?vue&type=script&lang=js&"
import style0 from "./WeightFieldDisplayEdit.vue?vue&type=style&index=0&id=5f2a5e17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a5e17",
  null
  
)

export default component.exports